import { useState } from 'react';

/**
 * A localStorage-backed dismissible flag → `[dismissed, dismiss]`. `value` is what's
 * written on dismiss (a date for per-day banners, or '1' for one-time). Storage
 * errors (private mode / disabled) are swallowed and treated as "not dismissed".
 */
export function useDismissible(key, value) {
  const [dismissed, setDismissed] = useState(() => {
    try { return localStorage.getItem(key) === value; } catch { return false; }
  });
  const dismiss = () => {
    try { localStorage.setItem(key, value); } catch { /* storage unavailable */ }
    setDismissed(true);
  };
  return [dismissed, dismiss];
}
